module.exports = __webpack_public_path__ + "img/logo-footer.438152a6.png";